import { motion } from "framer-motion";
import { QrCode } from "lucide-react";

const OTHERS = [
  { name: "Un GMAO", text: "organiza el mantenimiento." },
  { name: "Un ERP", text: "organiza operaciones y transacciones." },
  { name: "Un MES", text: "organiza la producción." },
  { name: "Un gestor documental", text: "organiza archivos." },
];

export default function Differentiation() {
  return (
    <section id="porque-nosotros" className="scroll-mt-20 bg-white border-y border-zinc-100" data-testid="diferenciacion-grid">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Por qué nosotros</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            No queremos ser otro software industrial complejo.
          </h2>
        </div>

        <div className="mt-16 max-w-4xl">
          {OTHERS.map((o, i) => (
            <motion.div
              key={o.name}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
              className="flex items-baseline gap-3 py-5 border-b border-zinc-100"
            >
              <p className="text-lg sm:text-xl text-zinc-500">
                <span className="font-medium text-zinc-700">{o.name}</span> {o.text}
              </p>
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.35 }}
            className="mt-10 rounded-3xl bg-zinc-950 text-white p-8 sm:p-12"
            data-testid="positioning-asset-passport"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-10 w-10 rounded-xl bg-white text-zinc-900 flex items-center justify-center">
                <QrCode size={18} />
              </span>
              <span className="font-heading font-bold tracking-tight text-lg">Asset Passport</span>
            </div>
            <p className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-tight">
              Nosotros organizamos la información alrededor de la máquina.
            </p>
            <p className="text-zinc-400 leading-relaxed mt-5 max-w-2xl">
              No venimos a sustituir tus sistemas. Creamos una capa sencilla alrededor del activo
              que le proporciona <span className="text-white">identidad</span>,{" "}
              <span className="text-white">documentación</span> y{" "}
              <span className="text-white">memoria</span>. Y en el futuro podrá convivir e
              integrarse con el resto de tu software.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
